function formatZip(zip: string) {
  if (!zip) return zip
  const replacedZip = zip.replace(/\D/g, '')
  if (replacedZip.length > 9) return replacedZip.substring(0, 9)
  if (replacedZip.length > 5) return `${replacedZip.substring(0, 5)}-${replacedZip.substring(5, 9)}`
  return replacedZip
}

export default formatZip
